import { ErrorBoundary as Boundary } from '@sentry/react';
import { VITE_ENVIRONMENT } from '../../envs';
import { Box } from '@mui/material';

export const ErrorBoundary = VITE_ENVIRONMENT !== 'production' ? Box : Boundary;
